// 9fbef606107a605d69c0edbcd8029e5d
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import isEmpty from 'lodash/isEmpty';
import React, { useEffect } from 'react';
import { getIsDynamicSizeChartEnabled } from '@tcp/core/src/reduxStore/selectors/session.selectors';
import DynamicSizeChart from '../views/DynamicSizeChart';
import { fetchDepartmentsRequest, fetchCategoriesRequest } from './DynamicSizeChart.actions';

import { getDepartments, getCategories } from './DynamicSizeChart.selector';

const DynamicSizeChartContainer = (props) => {
  const {
    isDynamicSizeChartEnabled,
    fetchDepartments,
    fetchCategories,
    departments,
    categoryData,
    isQuickView,
    primaryBrand,
    isModalView,
    activeSizeChart,
    isContentPage,
  } = props;

  useEffect(() => {
    if (isEmpty(departments)) {
      fetchDepartments();
    }
  }, [isEmpty(departments)]);

  if (!isDynamicSizeChartEnabled || isEmpty(departments)) return null;

  return (
    <DynamicSizeChart
      departmentVal={departments}
      categoryData={categoryData}
      fetchCategories={fetchCategories}
      isQuickView={isQuickView}
      primaryBrand={primaryBrand}
      isModalView={isModalView}
      activeSizeChart={activeSizeChart}
      isContentPage={isContentPage}
    />
  );
};

const mapStateToProps = (state) => {
  return {
    isDynamicSizeChartEnabled: getIsDynamicSizeChartEnabled(state),
    departments: getDepartments(state),
    categoryData: getCategories(state),
  };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    { fetchDepartments: fetchDepartmentsRequest, fetchCategories: fetchCategoriesRequest },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(DynamicSizeChartContainer);
